/**
 * @fileoverview Edit User read-only fields.
 * @description The facts the backend doesn't let Update User change (Employee ID, email,
 * department, date of joining), shown read-only at the top of the Edit dialog.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 * @author Anshul Rokde
 */

import { useTranslation } from 'react-i18next'

import { formatJoiningDate } from '@/features/users/utils/user-display.utils'
import DetailField from '@/shared/components/molecules/DetailField'

import type { UserDetail } from '@/features/users/types/users.types'

/**
 * @component
 * @param {{ user: UserDetail }} props - The user being edited.
 * @param {UserDetail} props.user - The user being edited.
 */
function EditUserReadOnlyFields({ user }: { user: UserDetail }) {
  const { t } = useTranslation()

  return (
    <>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.employeeId')}
        data-testid="edit-user-employee-id"
      >
        {user.employeeCode ?? '—'}
      </DetailField>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.email')}
        data-testid="edit-user-email"
      >
        {user.email}
      </DetailField>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.dept')}
        data-testid="edit-user-department"
      >
        {user.department?.name ?? '—'}
      </DetailField>
      <DetailField
        label={t('sales.userManagement.editUserForm.fields.doj')}
        data-testid="edit-user-joining-date"
      >
        {formatJoiningDate(user.dateOfJoining) ||
          t('sales.userManagement.editUserForm.fields.dojPending')}
      </DetailField>
    </>
  )
}

export default EditUserReadOnlyFields
